'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.replaceWindowElement = replaceWindowElement;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function replaceWindowElement(_ref) {
  var type = _ref.type,
      id = _ref.id,
      attributes = _ref.attributes,
      innerHTML = _ref.innerHTML,
      parentElement = _ref.parentElement;

  var removedElement = window.document.getElementById(id);
  if (removedElement) {
    var parent = removedElement.parentNode;
    parent.removeChild(removedElement);
  }
  var addedElement = window.document.createElement(type);
  addedElement.setAttribute('id', id);

  (0, _keys2.default)(attributes).forEach(function (key) {
    return addedElement.setAttribute(key, attributes[key]);
  });

  if (innerHTML) {
    addedElement.innerHTML = innerHTML;
  }

  parentElement.appendChild(addedElement);
}